<template>
  <el-dialog
    :title="$t('common.supportProducts')"
    :visible="visible"
    width="60%"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <div ref="supportContainer" class="supportContainer">
      <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="80px">
        <el-row v-for="(item, index) in form.supports" :key="index" :ref="'supportInfo' + index">
          <el-col :span="10">
            <el-form-item
              :label="$t('common.productName')"
              :prop="'supports.' + index + '.prod'"
              :rules="{
                  required: true,
                  validator: (rule, value, callback) => validateProd(rule, value, callback, index),
                  trigger: 'change'
                }">
              <el-select
                v-model="item.prod"
                clearable
                filterable
                size="small"
                style="width: 100%"
                @change="changeProd">
                <el-option
                  v-for="item in prodNoData"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              :label="$t('common.dailyProductionCapacity')"
              :prop="'supports.' + index + '.testDaily'"
              :rules="rules.testDaily">
              <el-input
                v-model.trim.number="item.testDaily"
                name="testDaily"
                type="tel"
                autocomplete="on"
                clearable
                maxlength="10"
                size="small">
                <template slot="append">K</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align: center;">
            <el-button
              type="text"
              class="link"
              @click="deleteSupport(index)">
              {{$t('common.delete')}}
            </el-button>
            <span class="vertical-separator"></span>
            <el-button
              type="text"
              class="link"
              @click="addSupport(index)">
              {{$t('common.add')}}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.sure')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import {productsList} from "@/api/products";
import {isPositiveIntegerNum, isValueEmpty} from "@/utils";
import i18n from "@/lang";

export default {
  name: "SupportProdNoDialog",
  props: {
    supportProducts: {
      type: Array,
      default: () => [],
    },
    visible: Boolean,
  },
  data() {
    const validateTestDaily = (rule, value, callback) => {
      if (isValueEmpty(value)) {
        callback(new Error(i18n.t('device.dailyProductionCapacityCanNotBeEmpty')));
        return false;
      }
      if (!isPositiveIntegerNum(value)) {
        callback(new Error(i18n.t('device.dailyProductionCapacityMustBeAPositiveInteger')));
        return false;
      }
      callback();
      return true;
    }
    return {
      prodNoData: [],
      form: {
        supports: [],
      },
      rules: {
        testDaily: [{
          required: true,
          trigger: 'change',
          validator: validateTestDaily,
        }]
      },
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.form.supports = [];
        for (let row of this.supportProducts) {
          this.form.supports.push({
            testDaily: row.testDaily,
            prod: row.prod,
          });
        }
        if (this.form.supports.length === 0) {
          this.form.supports = [{
            testDaily: undefined,
            prod: undefined,
          }];
        }
        this.productsList();
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
        this.$refs.refForm.clearValidate();
      }
    },
    async productsList() {
      try {
        const res = await productsList({
          page: 1,
          perpage: 5000,
        });
        const data = res.data;
        this.prodNoData = data.records.map(item => item.productName);
        this.prodNoData = [...new Set(this.prodNoData)];
      } catch (e) {
        // do nothing.
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.$emit('sure', [...this.form.supports]);
          this.close();
        }
      });
    },
    deleteSupport(index) {
      this.form.supports.splice(index, 1);
      this.$nextTick(() => {
        if (this.$refs.refForm) {
          this.$refs.refForm.clearValidate();
        }
      });
    },
    changeProd() {
      let fields = [];
      for (let i = 0, length = this.form.supports.length; i < length; i++) {
        fields.push('supports.' + i + '.prod');
      }
      this.$refs.refForm.validateField(fields);
    },
    validateProd(rule, value, callback, index) {
      if (isValueEmpty(value)) {
        callback(new Error(i18n.t('validate.productNameCanNotBeEmpty')));
        return false;
      }
      const {
        supports,
      } = this.form;
      for (let i = 0, length = supports.length; i < length; i++) {
        if (i !== index) {
          if (supports[i].prod === value) {
            callback(new Error(i18n.t('device.productNameRepeat')));
            return;
          }
        }
      }
      callback();
    },
    addSupport(index) {
      this.form.supports.splice(index + 1, 0, {
        testDaily: undefined,
        prod: undefined,
      });
      this.$nextTick(() => {
        if (this.$refs.refForm) {
          this.$refs.refForm.clearValidate();
        }
        this.$refs.supportContainer.scrollTop = this.$refs['supportInfo' + (index + 1)][0].$el.offsetTop - 80;
      });
    }
  }
}
</script>

<style scoped>
.supportContainer {
  overflow: auto;
  max-height: 50vh;
  padding: 15px;
}
.link {
  color: #169BD5;
  padding: 10px 5px;
}
.link.is-disabled {
  color: #C0C4CC;
}
.vertical-separator {
  display: inline-block;
  width: 1px;
  height: 12px;
  margin: 0 5px;
  vertical-align: middle;
  background: #e8e8e8;
}
</style>
